import { useState, useEffect } from 'react'
import './TypeWriter.css'

function TypeWriter({ text, speed = 100, delay = 500 }) {
  const [displayText, setDisplayText] = useState('')
  const [showCursor, setShowCursor] = useState(true)
  const [isTyping, setIsTyping] = useState(false)

  useEffect(() => {
    let timeout
    
    // 延迟后开始打字
    timeout = setTimeout(() => {
      setIsTyping(true)
      let currentIndex = 0
      
      const typeInterval = setInterval(() => {
        if (currentIndex < text.length) {
          setDisplayText(text.slice(0, currentIndex + 1))
          currentIndex++
        } else {
          clearInterval(typeInterval)
          setIsTyping(false)
        }
      }, speed)
    }, delay)

    return () => {
      clearTimeout(timeout)
    }
  }, [text, speed, delay])

  // 光标闪烁效果
  useEffect(() => {
    const cursorInterval = setInterval(() => {
      setShowCursor(prev => !prev)
    }, 530)

    return () => clearInterval(cursorInterval)
  }, [])

  return (
    <span className="typewriter">
      {displayText}
      <span 
        className={`typewriter-cursor ${showCursor ? 'visible' : ''} ${isTyping ? 'typing' : ''}`}
      >
        |
      </span>
    </span>
  )
}

export default TypeWriter
